<div>
    <div class="c-form-group">
        <div class="c-form-group__label"><label for="filterLabel">Main Filter Label</label></div>
        <input id="filterLabel" class="c-form-group__input" [(ngModel)]="sharedService.filterSetup.label" cclFormInput maxlength="20" />
        <div class="c-form-group__hint">&nbsp;</div>
    </div>
    <h5 class="c-label">Data</h5>
    <div class="c-form-group">
        <div class="c-form-group__label"><label for="displayOptionDropdown">Display Options for these fields..</label></div>
        <div class="flex-100 w100">
            <div ngbDropdown class="d-inline-block w100">
                <button class="btn c-form-group__input text-left w100" id="displayOptionDropdown" ngbDropdownToggle>
                    {{
                        sharedService.filterSetup.standardFields.length != 0 ||
                        sharedService.filterSetup.customFields.length != 0
                            ? "Selected Fields: " +
                              sharedService.filterSetup.standardFields.length +
                              " Standard, " +
                              sharedService.filterSetup.customFields.length +
                              " Custom"
                            : "No Field Selected"
                    }}
                </button>
                <div
                    ngbDropdownMenu
                    aria-labelledby="displayOptionDropdown"
                    class="w100 displayOptionDropdownContent"
                    (click)="$event.stopPropagation()"
                >
                    <div class="col-sm-12">
                        <h6 class="c-label--accent">Standard</h6>
                        <div class="col-sm-12 plr0">
                            <div *ngFor="let field of standardFields">
                                <ccl-checkbox
                                    class="text-capitalize"
                                    buttonStyle="c-checkbox"
                                    (clickEvent)="setDisplayOptions(field, 'standardFields')"
                                    [id]="field.code"
                                    [value]="sharedService.filterSetup.standardFields.indexOf(field.code) >= 0"
                                    ><b> {{ field.label }} </b></ccl-checkbox
                                >
                                <div style="margin-left:15px" *ngIf="field.label === 'Session Date'">
                                    <ccl-checkbox
                                        *ngFor="let date of dates"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectDate(date)"
                                        [id]="date.id"
                                        [value]="this.selectedDates.indexOf(date.id) >= 0"
                                        >{{ date.label }}</ccl-checkbox
                                    >
                                </div>
                                <div style="margin-left:15px" *ngIf="field.label === 'Session Time'">
                                    <ccl-checkbox
                                        *ngFor="let time of times"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectTime(time)"
                                        [id]="time.id"
                                        [value]="this.selectedTimes.indexOf(time.label) >= 0"
                                        >{{ time.label }}</ccl-checkbox
                                    >
                                </div>
                                <div style="margin-left:15px" *ngIf="field.label === 'Track'">
                                    <ccl-checkbox
                                        *ngFor="let track of tracks"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectTrack(track)"
                                        [id]="track.id"
                                        [value]="this.selectedTracks.indexOf(track.id) >= 0"
                                        >{{ track.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Session Type'">
                                    <ccl-checkbox
                                        *ngFor="let type of types"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectType(type)"
                                        [id]="type.id"
                                        [value]="this.selectedTypes.indexOf(type.id) >= 0"
                                        >{{ type.label }}</ccl-checkbox
                                    >
                                </div>
                                <div style="margin-left:15px" *ngIf="field.label === 'Session Level'">
                                    <ccl-checkbox
                                        *ngFor="let level of levels"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectLevel(level)"
                                        [id]="level.id"
                                        [value]="this.selectedLevels.indexOf(level.id) >= 0"
                                        >{{ level.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Session Location'">
                                    <ccl-checkbox
                                        *ngFor="let location of locations"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectLocation(location)"
                                        [id]="location.id"
                                        [value]="this.selectedLocations.indexOf(location.id) >= 0"
                                        >{{ location.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Tag'">
                                    <ccl-checkbox
                                        *ngFor="let tag of tags"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectTag(tag)"
                                        [id]="tag.id"
                                        [value]="this.selectedTags.indexOf(tag.id) >= 0"
                                        >{{ tag.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Industries'">
                                    <ccl-checkbox
                                        *ngFor="let industry of industries"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectIndustry(industry)"
                                        [id]="industry.id"
                                        [value]="this.selectedIndustries.indexOf(industry.id) >= 0"
                                        >{{ industry.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Job Functions'">
                                    <ccl-checkbox
                                        *ngFor="let job of jobFunctions"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectJobFunction(job)"
                                        [id]="job.id"
                                        [value]="this.selectedJobFunctions.indexOf(job.id) >= 0"
                                        >{{ job.label }}</ccl-checkbox
                                    >
                                </div>

                                <div style="margin-left:15px" *ngIf="field.label === 'Product Goal'">
                                    <ccl-checkbox
                                        *ngFor="let product of productGoals"
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="selectProductGoal(product)"
                                        [id]="product.id"
                                        [value]="this.selectedProductGoals.indexOf(product.id) >= 0"
                                        >{{ product.label }}</ccl-checkbox
                                    >
                                </div>
                            </div>
                        </div>
                        <div *ngIf="customFields.length > 0">
                            <h6 class="c-label--accent">Custom</h6>
                            <div class="col-sm-12 plr0">
                                <div *ngFor="let field of customFields">
                                    <ccl-checkbox
                                        class="text-capitalize"
                                        buttonStyle="c-checkbox"
                                        (clickEvent)="setDisplayOptions(field, 'customFields')"
                                        [id]="field.code"
                                        [value]="sharedService.filterSetup.customFields.indexOf(field.code) >= 0"
                                        > <b> {{ field.label }} </b></ccl-checkbox
                                    >
                                    <div style="margin-left:15px" *ngIf="showCustomFieldOptions">
                                        <ccl-checkbox
                                            *ngFor="let fieldValue of options[field.code]"
                                            class="text-capitalize"
                                            buttonStyle="c-checkbox"
                                            (clickEvent)="selectCustomFieldValues(field,fieldValue)"
                                            [id]="fieldValue.id"
                                            [value]="this.selectedOptions[field.code].indexOf(fieldValue.id) >= 0"
                                            >{{ fieldValue.label }}</ccl-checkbox
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-form-group__hint">&nbsp;</div>
    </div>
    <div class="c-form-group">
        <div class="flex-100 filterTypeContainer" ngxDroppable [model]="sharedService.filterSetup.selectedFields">
            <div
                class="filterTypeContainerItem text-capitalize ngx-dnd-container"
                *ngFor="let field of sharedService.filterSetup.selectedFields; let i = index"
                ngxDraggable
                [model]="field"
            >
                <span>{{
                    field.type == "standardFields" ? standardFieldLabels[field.field] : customFieldLabels[field.field]
                }}</span>
                &nbsp;
 	 	 	    <span class="date_range_warn" *ngIf="standardFieldLabels[field.field] == 'Session Date Range' || standardFieldLabels[field.field] == 'Session Date'" > *Either Session Date or Session Date Range should be selected. </span>
                <span (cclClick)="removeDisplayOptions(i, field)"><i class="fa fa-remove removeIcon" title="Remove"></i></span>
                <span class="c-draghandle-icon filter-drag-icon" ngxDragHandle>
                    <i class="fa fa-ellipsis-v c-draghandle-icon__dots" title="Drag"></i>
                    <i class="fa fa-ellipsis-v c-draghandle-icon__dots" title="Drag"></i>
                </span>
            </div>
        </div>
        <div class="c-form-group__hint">&nbsp;</div>
    </div>
    <div class="c-form-group">
        <div class="c-form-group__label"><label for="mysessions">My Sessions Filter</label>
        <div class="filter-my-session-label">
            <ccl-toggle-button
                [title]="sharedService.filterSetup.showMysessionsFilter ? 'Enable' : 'Disable'"
                [isChecked]="sharedService.filterSetup.showMysessionsFilter"
                (isCheckedChange)="toggleHTMLEnable($event,'showMysessionsFilter')"
                >{{ sharedService.filterSetup.showMysessionsFilter ? "Enabled" : "Disabled" }}</ccl-toggle-button
            >
        </div>
    </div>
        <div class="c-form-group__hint">&nbsp;</div>
    </div>
    
    <div *ngIf="false" class="c-form-group">
        <div class="c-form-group__label"><label for="cssStyle">CSS Styling</label></div>
        <textarea id="cssStyle"
            rows="10"
            class="form-control"
            [(ngModel)]="sharedService.filterSetup.styling"
            (focus)="beautifyCSS()"
            (focus)="beautifyCSS()"
        ></textarea>
        <div class="c-form-group__hint">&nbsp;</div>
    </div>
</div>
